import { WidgetDefinition } from '../global'
import { addToImportMap, esmSh } from './utils'

export class HolidayguruWidget extends HTMLElement {
  root: ShadowRoot | null = null
  definition: WidgetDefinition | null = null

  constructor() {
    super()
  }

  createCSS() {
    if (!this.definition?.css) return

    this.definition.css.forEach(({ css, target }) => {
      const styles = new CSSStyleSheet()
      styles.replaceSync(css)
      const root = target === 'shadow' ? this.root : document
      root?.adoptedStyleSheets.push(styles)
    })
  }

  async connectedCallback() {
    if (!this.definition) {
      throw new Error('Widget definition not set!')
    }
    const { reactVersion, dev } = this.definition

    this.root = this.attachShadow({ mode: 'open' })

    // Pre-render only if there are no attributes
    if (this.definition.attributes == null) {
      this.root.innerHTML = this.definition.html
    }

    this.createCSS()

    addToImportMap(
      ['react', 'react/jsx-runtime', 'react-dom', 'react-dom/client'].reduce(
        (all, resource) => ({
          ...all,
          [resource]: esmSh(resource, reactVersion, dev),
        }),
        {},
      ),
    )

    Promise.all([
      import('react'),
      import('react-dom/client'),
      import(this.definition.entry),
    ]).then(([{ createElement }, { hydrateRoot }, { default: component }]) => {
      const attrs = {} as Record<string, string>

      if (this.definition?.attributes) {
        Object.entries(this.definition.attributes).forEach(([key, value]) => {
          attrs[key] = this.getAttribute(key) ?? value
        })
      }

      hydrateRoot(
        this.root as unknown as Element,
        createElement(component, attrs),
      )
    })
  }
}
